import { FieldErrors, FieldValues } from "react-hook-form"

type FormattedError = { fieldName: string; validator: string; message?: string }

/**
 * Format errors from react-hook-form into a more usable format that can be iterated over and rendered
 */
export const formatErrors = (errors: FieldErrors<FieldValues>): FormattedError[] => {
    return Object.entries(errors).reduce((acc, [fieldName, error]) => {
        if (error) {
            if (error.type) {
                if (error.types) {
                    // Multiple errors for a single field
                    Object.entries(error.types).forEach(([validator, message]) => {
                        acc.push({ fieldName, validator, message })
                    })
                    return acc
                }
                acc.push({
                    fieldName,
                    validator: error.type,
                    message: error.message,
                })
            } else {
                // Deeply nested errors (ex: CustomFields)
                acc.push(...formatErrors(error as FieldErrors<FieldValues>)) // Don't love this
            }
        }
        return acc
    }, [])
}
